<template>
    <b-modal
            id="device-status-modal"
            no-footer
            title="Change device status">

        <!-- Change status -->
        <template v-if="!loadingRevisit">
            <empty-state
                    statusIcon="warning"
                    statusIconSize="4x"
                    title="Changing this device’s status may have an affect on your KPIs"
                    subtitle="Please ensure you select the correct status for this device and only update when applicable">
                <slot>
                    <select class="custom-select" v-model="selectedStatus">
                        <option selected>Open this select menu</option>
                        <option
                                v-for="status in filteredDeviceStatuses"
                                :key="status.key"
                                :value="status.id">
                            {{ status.title }}
                        </option>
                    </select>
                    <p class="text-left text-muted text-sm mt-2" v-if="!isRefurbOrMailIn"><strong>Hint:</strong> If required, the option to book a revisit will appear once you've clicked the Update Status button</p>
                </slot>

                <!-- Revisit bits -->
                <template v-if="!isRefurbOrMailIn">
                    <template v-if="revisitRequired && isOnline && !isSelfServe">
                        <h2 class="mt-4">Revisit Required</h2>
                        <p>A revisit booking is required for this status change, either click below to book a revisit or change the status.</p>
                        <button type="button" class="btn btn-danger mb-0" @click="bookRevisitLoadJob()">Book Revisit</button>
                    </template>

                    <template v-if="revisitRequired && isOffline">
                        <h2 class="mt-4">Revisit Required</h2>
                        <p>A revisit is required for this order, however you are currently offline.</p>
                    </template>

                    <template v-if="revisitRequired && isSelfServe">
                        <h2 class="mt-4">Revisit Required</h2>
                        <p>A revisit is required to complete this job, as the customer is not available click the button below to send them a self serve revisit booking form.</p>
                        <button type="button" class="btn btn-danger mb-0" @click="bookRevisitSelfServe()">Send Form</button>
                    </template>
                </template>
                <template v-if="isRefurbOrMailIn && revisitRequired">
                    <div class="alert alert-info mb-0 mt-4">
                        <animated-info></animated-info>
                        <div class="alert-content">Please return this device to the office.</div>
                    </div>
                </template>

            </empty-state>
        </template>

        <!-- Loading revisit -->
        <empty-state
                v-if="loadingRevisit"
                class="bg-transparent"
                statusIcon="loading"
                title="Loading revisit booking"
                subtitle="Please wait">
        </empty-state>

        <template v-slot:modal-footer>
            <button type="button" class="btn btn-light" @click="$bvModal.hide('device-status-modal')">Cancel</button>
            <button type="button" class="btn btn-success" @click="updateDeviceStatus()" :disabled="loadingRevisit">Update status</button>
        </template>
    </b-modal>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';

    export default {
        props:['jobId', 'deviceId'],

        data() {
            return {
                isSelfServe: false,
                loadingRevisit: false,
                revisitRequired: false,
                selectedStatus: null
            }
        },

        mounted() {
            this.revisitRequired = false;
            this.loadDeviceStatuses();
        },

        computed: {
            ...mapGetters([
                "device",
                "deviceStatus",
                "deviceStatuses",
                "job",
                "isRefurbOrMailIn"
            ]),

            filteredDeviceStatuses() {
                let filtered = this.deviceStatuses.filter((el) => {
                    return (el.title && el.title !== "Completed" && el.title !== "Repaired Pending QC")
                });

                return filtered;
            }
        },

        methods: {
            ...mapActions([
                "loadDeviceStatuses",
                "loadDeviceStatus",
                "setDeviceComplete",
                "setDeviceNotComplete",
                "setDeviceStatus"
            ]),

            /** Revisit load job */
            bookRevisitLoadJob() {
                this.loadingRevisit = true;
                this.$http.get(`/api/v4/warranty/booking/build/${this.job.actual_order_id}`)
                .then(res => {
                    localStorage.revisitBookingId = res.data.data.booking_reference;
                    this.loadingRevisit = false;

                    if (res.data.data.order.devices.length !== 1) {
                        this.$router.push(`/jobs/${this.jobId}/book-revisit/device`);
                        return;
                    }

                    this.$router.push(`/jobs/${this.jobId}/book-revisit`)
                });
            },

            /** Revisit self serve */
            bookRevisitSelfServe() {
                this.loadingRevisit = true;
                this.$http.post(`/api/v4/orders/${this.job.order_id}/revisit-invitation`, {
                    "reason": "Sorry we missed you, click below to book a revisit."
                }).then(() => {
                    this.loadingRevisit = false;
                    this.$bvModal.hide('device-status-modal');
                    this.$router.push('job');
                });
            },

            /** Update the device status */
            updateDeviceStatus() {
                let revisitRequired = false;
                this.isSelfServe = false;

                this.deviceStatuses.forEach(status => {
                    if (status.id === this.selectedStatus) {
                        revisitRequired = status.revisit_required;

                        if (this.selectedStatus == 3 || this.selectedStatus == 4) {
                            this.isSelfServe = true;
                        }
                    }
                });

                this.setDeviceStatus({
                    jobId:this.jobId,
                    deviceId: this.deviceId,
                    status: this.selectedStatus
                }).then(() => {
                    // If status is Completed
                    if (this.selectedStatus === "1") {
                        this.setDeviceComplete({
                            jobId:this.jobId,
                            deviceId:this.deviceId
                        }).then(() => {
                            this.loadDeviceStatus({
                                statusId: this.device.status_id
                            });
                            this.$bvModal.hide('device-status-modal');
                        });
                        // If status is NOT Completed
                    } else if (this.selectedStatus !== "1") {
                        this.setDeviceNotComplete({
                            jobId:this.jobId,
                            deviceId:this.deviceId
                        }).then(() => {
                            this.loadDeviceStatus({
                                statusId: this.device.status_id
                            });

                            if (!revisitRequired) {
                                this.$bvModal.hide('device-status-modal');
                            }

                            this.revisitRequired = true;
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
